// Mejora progresiva: conserva los nodos, valores y listeners de las vistas existentes.
let observer
let scheduled = false

function adaptTable(table) {
  if (table.closest(".inventory-lines-region, [data-price-catalog], [data-ui-native]")) return
  const initialized = table.dataset.appAdapted
  table.dataset.appAdapted = "true"
  table.classList.add("app-data-table")

  // El contenedor pertenece a la tabla, no al formulario ni a toda la tarjeta.
  let region = table.parentElement
  if (!region.classList.contains("app-table-region")) {
    region = document.createElement("div")
    region.className = "app-table-region"
    table.before(region)
    region.append(table)
  }
  region.setAttribute("role", "region")
  const fitted = ["fit", "cards"].includes(table.dataset.responsive)
  region.setAttribute("aria-label", table.caption?.textContent.trim() || (fitted ? "Tabla de datos" : "Tabla de datos; desplaza para ver todas las columnas"))
  region.tabIndex = 0

  const headers = Array.from(table.tHead?.rows || [])
  const rows = Array.from(table.tBodies).flatMap(body => Array.from(body.rows))
  table.classList.toggle("app-table-keyvalue", headers.length === 0 && rows.length > 0 && rows.every(row => row.cells.length === 2))
  const cells = headers.length === 1 ? Array.from(headers[0].cells) : []
  const originalLabels = cells.map(cell => cell.textContent.trim())
  const expandedLabels = cells.flatMap(cell => Array(cell.colSpan).fill(cell.textContent.trim()))
  const labels = rows[0]?.cells.length === expandedLabels.length ? expandedLabels : originalLabels
  cells.forEach(cell => { if (!cell.hasAttribute("scope")) cell.setAttribute("scope", "col") })
  const simple = cells.length > 0 && rows.length > 0 && rows.every(row =>
    Array.from(row.cells).every(cell => cell.colSpan === 1 && cell.rowSpan === 1) && row.cells.length === labels.length)
  const matrix = table.dataset.responsive !== "cards" && (table.dataset.responsive === "fit" || document.body.dataset.uiController === "reports" || document.body.dataset.uiAction === "prices_index" ||
    table.dataset.responsive === "scroll" || table.classList.contains("dataTable") || !!table.tHead?.querySelector("input, button, select, a[href]"))
  table.classList.toggle("app-table-cards", simple && !matrix)
  if (simple && !matrix) {
    table.classList.add("app-table-cards")
    rows.forEach(row => Array.from(row.cells).forEach((cell, index) => {
      const label = labels[index] || "Acciones"
      if (!cell.hasAttribute("data-label")) cell.dataset.label = label
      if (!cell.textContent.trim() && !cell.querySelector("input, img, button, a, select")) cell.classList.add("app-cell-empty")
      if (/producto|nombre|descripci|observaci|direcci|nota/i.test(label)) cell.classList.add("app-cell-wide")
      if (/^(acciones|ver|editar|eliminar|otros)$/i.test(label)) cell.classList.add("app-cell-action")
    }))
  }
  if (!initialized && !fitted) {
    const hint = document.createElement("p")
    hint.className = "app-table-hint"
    hint.textContent = "Desliza la tabla para ver todas las columnas."
    region.after(hint)
  }
}

function enhanceContent() {
  const content = document.querySelector("[data-app-content]")
  if (!content) return
  content.querySelectorAll("table").forEach(adaptTable)
  content.querySelectorAll("form").forEach(form => {
    const fields = Array.from(form.children)
    if (fields.length >= 5 && fields.every(field => field.matches(".field, .form-group, .actions, #error_explanation, input[type='hidden']"))) {
      form.classList.add("app-form-grid")
    }
  })
  if (!content.querySelector(".card, .app-overview, .inventory-document, .price-catalog, .gtech-support, .m-card")) content.classList.add("app-surface")
}

function initializeAppExperience() {
  observer?.disconnect()
  if (!document.body.classList.contains("app-shell")) return
  enhanceContent()
  document.querySelectorAll("#kt_header_menu a[href]").forEach(link => {
    const url = new URL(link.href, location.href)
    if (url.pathname === location.pathname && !url.hash) link.setAttribute("aria-current", "page")
    else link.removeAttribute("aria-current")
  })
  const content = document.querySelector("[data-app-content]")
  if (!content) return
  observer = new MutationObserver(() => {
    if (scheduled) return
    scheduled = true
    requestAnimationFrame(() => {
      scheduled = false
      enhanceContent()
    })
  })
  observer.observe(content, { childList: true, subtree: true })
}

document.addEventListener("turbolinks:load", initializeAppExperience)
document.addEventListener("DOMContentLoaded", initializeAppExperience)
document.addEventListener("turbolinks:before-cache", () => observer?.disconnect())
